// ForgotPassword.js
import React, { useState } from "react";

import './SignIn.css'; // Import the shared CSS file

export default function ForgotPassword() {
    // --- NO CHANGES TO LOGIC OR STATE ---
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setMessage("");
        setError("");
        setLoading(true);

        try {
            const response = await fetch(`/forgot-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });
            const data = await response.json();
            if (response.ok) {
                setMessage(data.message);
            } else {
                setError(data.message || 'An error occurred.');
            }
        } catch (err) {
            setError('Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    // --- END OF UNCHANGED LOGIC ---

    return (
        <div className="container-fluid p-0">
            <div className="row g-0 vh-100">
                {/* Left Branding Panel */}
                <div className="col-lg-6 d-none d-lg-block auth-branding-panel h-100">
                    <div className="p-5">
                        <h1>KlonIT</h1>
                        <p className="lead">Let's get you back into your account.</p>
                    </div>
                </div>

                {/* Right Form Panel */}
                <div className="col-lg-6 auth-form-panel">
                    <div className="auth-form-container">
                        
                        <div className="text-center mb-4">
                            <h1 className="h2 fw-bold">Reset Password</h1>
                            <p className="lead">
                                Enter your email and we'll send you a link to get back into your account.
                            </p>
                        </div>

                        {message && <div className="alert alert-success">{message}</div>}
                        {error && <div className="alert alert-danger">{error}</div>}

                        {/* Hide form if success message is shown */}
                        {!message && (
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label">Email</label>
                                    <input
                                        className="form-control form-control-lg"
                                        type="email"
                                        name="email"
                                        placeholder="Enter your email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="d-grid gap-2 mt-4">
                                    <button type="submit" className="btn btn-lg btn-primary" disabled={loading}>
                                        {loading ? 'Sending...' : 'Send Reset Link'}
                                    </button>
                                </div>
                            </form>
                        )}
                        
                        <div className="text-center mt-4">
                           <a href="/Login">Back to Sign In</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}